import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

interface BlogPostSkeletonProps {
  notFound?: boolean;
}

const BlogPostSkeleton = ({ notFound = false }: BlogPostSkeletonProps) => {
  if (notFound) {
    return (
      <div className="pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">Post não encontrado</h1>
          <p className="text-gray-600 dark:text-gray-400 mb-8">O artigo que você está procurando não existe ou foi removido.</p>
          <Button asChild>
            <Link to="/blog">Voltar para o Blog</Link>
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-24 pb-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="animate-pulse">
          <div className="h-8 bg-gray-700 rounded w-3/4 mb-6"></div>
          <div className="h-80 bg-gray-800 rounded-lg mb-8"></div>
          <div className="space-y-4">
            <div className="h-4 bg-gray-700 rounded w-full"></div>
            <div className="h-4 bg-gray-700 rounded w-5/6"></div>
            <div className="h-4 bg-gray-700 rounded w-full"></div>
            <div className="h-4 bg-gray-700 rounded w-4/6"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogPostSkeleton;
